/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: 16,
        height: 18,
        viewBox: "0 0 16 18",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ _jsx(Path, {
            d: "M10.48 16.82c-.14-.28.08-.52.12-.78q.15-1.08 0-2.16a6 6 0 0 0-1.08-2.66 6 6 0 0 0-1.95-1.8q-.03-.02-.1-.01c-.12.09-.14.23-.15.4a4.4 4.4 0 0 1-1.2 2.86l-.93 1.03a3 3 0 0 0-.74 2.06q.01.18-.04.35l-.07.1a.4.4 0 0 1-.32-.1 5.9 5.9 0 0 1-2.01-4.4 11.59 11.59 0 0 1 1.03-5.64q.74-1.57 1.91-2.86A8 8 0 0 1 7.4 1.14c.1-.05.35-.17.46-.13.15.04.1.24.11.39a8.2 8.2 0 0 0 2.05 5.4c.58.64 1.2 1.25 1.75 1.93.64.8 1.1 1.67 1.24 2.7a5.6 5.6 0 0 1-.5 3.48c-.36.7-.87 1.24-1.46 1.73q-.2.16-.45.22z",
            stroke: "currentColor",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            vectorEffect: "non-scaling-stroke"
        })
    }));
};
export default SvgComponent;
